import { z } from "zod";

export const UserOnboardingDepartment = z.enum(["Design", "Engineering", "Product", "Brand", "Other"]);
export const UserOnboardingJobLevel = z.enum(["Executive", "Manager", "IndividualContributor", "Other"]);

const userThemePresets = [
  "Custom",
  "Default",
  "HighContrast",
  "DefaultDark",
  "HighContrastDark",
  "SpaceBlue",
  "DarkGrey",
  "SystemPreference",
  "Sepia",
] as const;

const portalThemePresets = [...userThemePresets, "DefaultPortal"] as const;

export const PortalThemePreset = z.enum(portalThemePresets);
export const UserThemePreset = z.enum(userThemePresets);

export const BaseTheme = z.object({
  backgroundColor: z.string().optional(),
  accentColor: z.string().optional(),
  contrast: z.number().min(16).max(100).optional(),
  isSecondaryEnabled: z.boolean().optional(),
  secondaryBackgroundColor: z.string().optional(),
  secondaryContrast: z.number().min(16).max(100).optional(),
  isEditorWhite: z.boolean().optional(),
});

export const UserTheme = BaseTheme.extend({
  preset: UserThemePreset.optional(),
});

export const PortalTheme = BaseTheme.extend({
  preset: PortalThemePreset.optional(),
});

export const UserOnboarding = z.object({
  companyName: z.string().optional(),
  numberOfPeopleInOrg: z.string().optional(),
  numberOfPeopleInDesignTeam: z.string().optional(),
  department: UserOnboardingDepartment.optional(),
  jobTitle: z.string().optional(),
  phase: z.string().optional(),
  jobLevel: UserOnboardingJobLevel.optional(),
  designSystemName: z.string().optional(),
  defaultDestination: z.string().optional(),
  figmaUrl: z.string().optional(),
  isPageDraftOnboardingFinished: z.boolean().optional(),
  isApprovalsOnboardingFinished: z.boolean().optional(),
});

export const UserProfile = z.object({
  name: z.string(),
  avatar: z.string().optional(),
  nickname: z.string().optional(),
  onboarding: UserOnboarding.optional(),
  theme: UserTheme.optional(),
  portalTheme: PortalTheme.optional(),
});

export type UserOnboardingDepartment = z.infer<typeof UserOnboardingDepartment>;
export type UserOnboardingJobLevel = z.infer<typeof UserOnboardingJobLevel>;
export type UserOnboarding = z.infer<typeof UserOnboarding>;
export type PortalThemePreset = z.infer<typeof PortalThemePreset>;
export type UserThemePreset = z.infer<typeof UserThemePreset>;
export type UserTheme = z.infer<typeof UserTheme>;
export type PortalTheme = z.infer<typeof PortalTheme>;
export type UserProfile = z.infer<typeof UserProfile>;

//
// TO DELETE
//

export const UserProfileUpdate = UserProfile.partial().omit({
  avatar: true,
});

export type UserProfileUpdate = z.infer<typeof UserProfileUpdate>;
